import { Component } from '@angular/core';
import { AnalyticsService } from '../../../services/analytics.service';

@Component({
  selector: 'app-heatmap-sessions',
  templateUrl: './heatmap-sessions.component.html',
  styleUrl: './heatmap-sessions.component.scss',
})
export class HeatmapSessionsComponent {
  isLoading = true;

  constructor(protected analyticsService: AnalyticsService) {
    this.analyticsService.sessionsHeatmap$.subscribe((data) => {});
    this.analyticsService.isLoading$.subscribe((loading) => {
      this.isLoading = loading.includes('sessionsHeatmap');
    });
    this.getChartData();
  }

  getChartData() {
    this.analyticsService.getSessionsHeatmap().subscribe();
  }

  get series() {
    return this.analyticsService.sessionsHeatmap$.value?.series;
  }

  get xLabels() {
    return this.analyticsService.sessionsHeatmap$.value?.hours;
  }

  get yLabels() {
    return this.analyticsService.sessionsHeatmap$.value?.days;
  }
}
